// eslint-disable-next-line @tseslint/no-shadow
import { ChangeDetectionStrategy, Component, EventEmitter, model, ModelSignal, Output } from '@angular/core';
import { SideMenuTitleComponent } from "@shared/components/side-menu/components/side-menu-title/side-menu-title.component";
import { SideMenuContentComponent } from "@shared/components/side-menu/components/side-menu-content/side-menu-content.component";
import { SideMenuGroupComponent } from "@shared/components/side-menu/components/side-menu-group/side-menu-group.component";
import { SideMenuGroupTitleComponent } from "@shared/components/side-menu/components/side-menu-group/components/side-menu-group-header/side-menu-group-title.component";
import { SideMenuGroupContentComponent } from "@shared/components/side-menu/components/side-menu-group/components/side-menu-group-content/side-menu-group-content.component";
import { MatRadioModule } from '@angular/material/radio';
import { provideTranslationScope, TranslationPipeModule } from '@ogs-gmbh/ngx-translate';
import { SideMenuComponent } from "@shared/components/side-menu/side-menu.component";
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-project-special-holiday-menu',
  standalone: true,
  imports: [ SideMenuTitleComponent,
    SideMenuContentComponent,
    SideMenuGroupComponent,
    SideMenuGroupTitleComponent,
    SideMenuGroupContentComponent,
    MatRadioModule,
    TranslationPipeModule,
    SideMenuComponent,
    MatButtonModule ],
  providers: [ provideTranslationScope("feature/project-special-times-holiday-menu") ],
  templateUrl: './project-special-times-holiday-menu.component.html',
  styleUrl: './project-special-times-holiday-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectSpecialTimesHolidayMenuComponent {
  public isExpanded: ModelSignal<boolean> = model(false);

  @Output() public readonly addHolidays: EventEmitter<void> = new EventEmitter<void>();

  protected _addHolidays (): void {
    this.addHolidays.emit();
  }
}
